var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import * as React from 'react';
import { Breadcrumb } from '@fluentui/react';
/**
 * FM team-navigation breadcrumb (F8) — React port of the GRM manager breadcrumb trail
 * (`CreateBreadcrumb`/`NavigateBreadcrumb`). The last item is the current (non-navigable) crumb.
 */
export const FMBreadcrumb = ({ items, onNavigate }) => {
    const bcItems = items.map((it, i) => ({
        key: it.key,
        text: it.text,
        isCurrentItem: i === items.length - 1,
        onClick: i === items.length - 1 ? undefined : () => onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(it),
    }));
    return React.createElement(Breadcrumb, { items: bcItems, ariaLabel: "FM team navigation" });
};
export default FMBreadcrumb;
//# sourceMappingURL=FMBreadcrumb.js.map